import React, { Component } from 'react';
import { Collapse } from 'react-bootstrap';
import Switch from 'react-switch';

import moment from 'moment';

import { getUTM } from '../../../utils/locationUtil';
import { knownTrackTypes } from '../../../utils/ontologyUtil';
import { getAgentDisplayName } from '../../../utils/agentUtil';
import { shouldShowResultTag } from '../../../utils/observationTypeUtil';

import './Observation.scss';

const truncateTagLabel = value => {
  const text = (value || '').toString().trim();
  if (text.length <= 24) return text;
  return `${text.slice(0, 24)}...`;
};

class TrackItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      UTM: false
    };
  }

  handleSwitch = value => {
    this.setState({ UTM: value });
  };

  render() {
    const { item, ...props } = this.props;
    const agentDisplayName = getAgentDisplayName(item);
    const attributes = Array.isArray(item.attributes) ? item.attributes : [];
    const trackDescriptionAttr = attributes.find(
      attribute => attribute.key === 'track_description'
    );
    const trackTeamMembersAttr = attributes.find(
      attribute => attribute.key === 'track_team_members'
    );
    const visibleConcepts = Array.isArray(item.concepts)
      ? item.concepts.filter(concept => shouldShowResultTag(concept.label))
      : [];
    const visibleSingleConcept = Array.isArray(item.concepts)
      ? null
      : shouldShowResultTag(item.concepts)
      ? item.concepts
      : null;
    const trackTypeLabels = {
      'track/onPatrol': 'Track - On Patrol',
      'track/onDuty': 'Track - On Duty',
      'track/onFootPatrol': 'Track - Foot Patrol',
      'track/onVehiclePatrol': 'Track - Vehicle Patrol',
      'track/onAirPatrol': 'Track - Air Patrol',
      'track/onHumanSpoor': 'Track - On Human Spoor',
      'track/onAnimalSpoor': 'Track - On Animal Spoor',
      'track/onSafari': 'Track - On Safari',
      'track/onCensus': 'Track - Census',
      'track/onFenceInspection': 'Track - Fence Inspection',
      'track/onK9Patrol': 'Track - On K9 Patrol',
      'track/onPerimeterTrack': 'Track - On Perimeter Track',
      'track/onSearch': 'Track - On Search',
      'track/onSnareSweep': 'Track - On Snare Sweep',
      'track/onBoatPatrol': 'Track - On Boat Patrol',
      'track/onDronePatrol': 'Track - On Drone Patrol',
      'track/onFastResponse': 'Track - On Fast Response',
      'track/onTraining': 'Track - Training',
      'track/onBikePatrol': 'Track - Bike Patrol',
      'track/vehicleTracker': 'Track - Vehicle Tracker'
    };
    const trackLabel =
      trackTypeLabels[item.featureType] ||
      (item.featureType === 'track/undefined'
        ? 'Track'
        : !knownTrackTypes.includes(item.featureType)
        ? `Track - ${item.featureType}`
        : null);
    const hasExplicitCount =
      props.trackObservationCount !== null &&
      props.trackObservationCount !== undefined;
    const observationCount = hasExplicitCount
      ? Math.max(0, Number(props.trackObservationCount) || 0)
      : 0;
    const hasObservations = observationCount > 0;
    return (
      <div
        id={item.featureId}
        className={`result-item card container rounded-0 border-left-0 border-top-0 border-right-0 border-bottom p-0 ${
          props.selected ? 'selected' : ''
        } ${props.viewed ? 'viewed' : ''}`}
      >
        <div className="row no-gutters">
          <div className="col-auto pl-2 pr-3 pt-3 pb-3 ml-1 photoItem">
            <div
              className={`attachment-container track-observation-badge ${
                hasObservations ? 'has-media' : 'no-media'
              }`}
              role="button"
              onClick={e => {
                e.stopPropagation();
                if (!hasObservations) {
                  props.setSelectedItem(item);
                  return;
                }
                if (props.onObservationBadgeClick) {
                  props.onObservationBadgeClick(item);
                  return;
                }
                props.setSelectedItem(item);
              }}
            >
              <span className="eye-badge-icon" aria-hidden="true">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 12C4.9 7.9 8.1 5.9 12 5.9C15.9 5.9 19.1 7.9 21.5 12C19.1 16.1 15.9 18.1 12 18.1C8.1 18.1 4.9 16.1 2.5 12Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="2.8"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                </svg>
                {!hasObservations && <span className="eye-badge-slash" />}
              </span>
              {hasExplicitCount && hasObservations && (
                <span className="number">{observationCount}</span>
              )}
            </div>
          </div>
          <div className="col">
            <div
              className="card-block pl-0 pr-3 py-2 pt-3"
              onClick={() => props.setSelectedItem(item)}
            >
              <h6 className="card-title mb-2 mt-1 font-weight-bold pointer">
                {trackLabel && (
                  <span className="track-title-with-icon">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="track-result-type-icon"
                      style={
                        props.trackColor ? { color: props.trackColor } : null
                      }
                    >
                      <circle
                        cx="2.25"
                        cy="12.5"
                        r="1.75"
                        fill="currentColor"
                      />
                      <circle
                        cx="13.75"
                        cy="3.5"
                        r="1.75"
                        fill="currentColor"
                      />
                      <path
                        d="M4.25 11.75L8.1 7.9C8.65 7.35 9.35 7 10.1 6.9L11.7 6.7C12.6 6.58 13.3 5.87 13.4 4.96L13.5 4"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="track-result-type-label">
                      {trackLabel}
                    </span>
                  </span>
                )}
                <span className="track-row-actions">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-collapse"
                    data-toggle="collapse"
                    href="#multiCollapseTrack"
                    aria-expanded="false"
                    aria-controls="multiCollapseTrack"
                    onClick={e => {
                      e.stopPropagation();
                      props.setSelectedItem(item);
                      props.openTrack(item);
                      // this.setState({ open: !this.state.open})
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-box-arrow-up-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
                      />
                      <path
                        fillRule="evenodd"
                        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm btn-collapse track-playback-toggle"
                    disabled={props.playbackDisabled}
                    onClick={e => {
                      e.stopPropagation();
                      if (props.onTogglePlayback) {
                        props.onTogglePlayback(item);
                      }
                    }}
                    aria-label={
                      props.isPlaybackActive
                        ? 'Pause track playback'
                        : 'Play track playback'
                    }
                  >
                    <span className="material-icons track-playback-icon">
                      {props.isPlaybackActive ? 'pause' : 'play_arrow'}
                    </span>
                  </button>
                </span>
              </h6>
              <div className="card-text mb-2 text-muted font-weight-light ">
                {agentDisplayName && (
                  <div className="mb-1">
                    <span className="">Agent name • </span>
                    <span className="">{agentDisplayName}</span>
                  </div>
                )}
                {item.startWhen && (
                  <div className="mb-1">
                    <span className="">Start track • </span>
                    <span className="">
                      {moment(item.startWhen).format('DD MMM YYYY - HH:mm')}
                    </span>
                  </div>
                )}
                {item.endWhen && (
                  <div className="mb-1">
                    <span className="">End track • </span>
                    <span className="">
                      {moment(item.endWhen).format('DD MMM YYYY - HH:mm')}
                    </span>
                  </div>
                )}
                {item['length'] != undefined && (
                  <div className="mb-1">
                    <span className="">Length • </span>
                    <span className="">{item.length.toFixed(3)} KM</span>
                  </div>
                )}
                {visibleConcepts.map((concept, key) => (
                  <span
                    key={key}
                    className="badge badge-secondary p-2 mr-1 mb-1 text-uppercase"
                  >
                    {truncateTagLabel(concept.label)}
                  </span>
                ))}
                {visibleSingleConcept && (
                  <span className="badge badge-secondary p-2 mr-1 mb-1 text-uppercase">
                    {truncateTagLabel(visibleSingleConcept)}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row no-gutters">
          <div className="col mt-0">
            <Collapse in={this.state.open}>
              <div id="multiCollapseTrack">
                <div className="card card-body rounded-0 border  m-3 mt-0 pb-0 bg-light">
                  <ul className="list-group ">
                    <form>
                      <div className="form-group">
                        {agentDisplayName && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Name
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {agentDisplayName}
                            </label>
                          </div>
                        )}

                        {item.startWhen && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-12 col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Start track
                            </label>
                            <label
                              htmlFor=""
                              className="col-12 col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {moment(item.startWhen).format(
                                'DD MMM YYYY - HH:mm'
                              )}
                            </label>
                          </div>
                        )}

                        {item.endWhen && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              End track
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {moment(item.endWhen).format(
                                'DD MMM YYYY - HH:mm'
                              )}
                            </label>
                          </div>
                        )}

                        {item.group && item.group.groupName && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Group
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {item.group.groupName}
                            </label>
                          </div>
                        )}

                        {item['length'] != undefined && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Length
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {item.length.toFixed(2)} KM
                            </label>
                          </div>
                        )}

                        {trackDescriptionAttr != undefined && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Description
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {trackDescriptionAttr.value}
                            </label>
                          </div>
                        )}

                        {trackTeamMembersAttr != undefined && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Team members
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {trackTeamMembersAttr.value}
                            </label>
                          </div>
                        )}

                        {item.startWhere && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Start point
                            </label>
                            {!this.state.UTM && (
                              <label
                                htmlFor=""
                                className="col-md-6 col-lg-9 col-form-label font-weight-light"
                              >
                                {item.startWhere.coordinates[0]},{' '}
                                {item.startWhere.coordinates[1]}
                              </label>
                            )}
                            {this.state.UTM && (
                              <label
                                htmlFor=""
                                className="col-md-6 col-lg-9 col-form-label font-weight-light"
                              >
                                {getUTM(
                                  item.startWhere.coordinates[1],
                                  item.startWhere.coordinates[0]
                                )}
                              </label>
                            )}
                          </div>
                        )}

                        {item.endWhere && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              End point
                            </label>
                            {!this.state.UTM && (
                              <label
                                htmlFor=""
                                className="col-md-6 col-lg-9 col-form-label font-weight-light"
                              >
                                {item.endWhere.coordinates[0]},{' '}
                                {item.endWhere.coordinates[1]}
                              </label>
                            )}
                            {this.state.UTM && (
                              <label
                                htmlFor=""
                                className="col-md-6 col-lg-9 col-form-label font-weight-light"
                              >
                                {getUTM(
                                  item.endWhere.coordinates[1],
                                  item.endWhere.coordinates[0]
                                )}
                              </label>
                            )}
                          </div>
                        )}

                        {(item.startWhere || item.endWhere) && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              WGS84
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-2 col-form-label font-weight-light m-0 p-0 mt-1"
                            >
                              <Switch
                                height={21}
                                width={42}
                                onChange={this.handleSwitch}
                                checked={this.state.UTM}
                                uncheckedIcon={false}
                                checkedIcon={false}
                              />{' '}
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              UTM
                            </label>
                          </div>
                        )}

                        {item.featureId && (
                          <div className="row no-gutters">
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-3 col-form-label text-muted"
                            >
                              Track ID
                            </label>
                            <label
                              htmlFor=""
                              className="col-md-6 col-lg-9 col-form-label font-weight-light"
                            >
                              {item.featureId}
                            </label>
                          </div>
                        )}
                      </div>
                    </form>
                  </ul>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

export default TrackItem;
